import { render, staticRenderFns } from "./AvatarButtonDropdown.vue?vue&type=template&id=e1990ff8"
import script from "./AvatarButtonDropdown.vue?vue&type=script&lang=js"
export * from "./AvatarButtonDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports